import React, { useEffect, useState } from "react";

/**
 * AIBackground — subtle ambient gradient mesh + soft drifting particles.
 * Runs only when prefers-reduced-motion is not set.
 */
const AIBackground = () => {
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const handler = () => setReduceMotion(media.matches);
    handler();
    if (media.addEventListener) media.addEventListener("change", handler);
    else media.addListener(handler);
    return () => {
      if (media.removeEventListener) media.removeEventListener("change", handler);
      else media.removeListener(handler);
    };
  }, []);

  if (reduceMotion) {
    return <div aria-hidden="true" className="fixed inset-0 z-0 pointer-events-none" />;
  }

  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true">
      {/* Soft purple orb */}
      <div
        className="absolute rounded-full"
        style={{
          width: 720,
          height: 720,
          left: "-15%",
          top: "-20%",
          background:
            "radial-gradient(circle at 20% 20%, rgba(124, 58, 237, 0.50), rgba(168, 85, 247, 0.20) 35%, transparent 70%)",
          filter: "blur(100px)",
          opacity: 0.22,
          animation: "ai-blob 22s ease-in-out infinite",
        }}
      />

      {/* Cool cyan orb */}
      <div
        className="absolute rounded-full"
        style={{
          width: 600,
          height: 600,
          right: "-10%",
          bottom: "-15%",
          background:
            "radial-gradient(circle at 80% 80%, rgba(34, 211, 238, 0.42), rgba(99, 102, 241, 0.16) 35%, transparent 70%)",
          filter: "blur(110px)",
          opacity: 0.18,
          animation: "ai-blob 28s ease-in-out infinite",
          animationDelay: "5s",
        }}
      />

      {/* Indigo accent */}
      <div
        className="absolute rounded-full"
        style={{
          width: 460,
          height: 460,
          left: "55%",
          top: "30%",
          background:
            "radial-gradient(circle at 50% 50%, rgba(129, 140, 248, 0.30), transparent 70%)",
          filter: "blur(90px)",
          opacity: 0.14,
          animation: "ai-blob 32s ease-in-out infinite reverse",
          animationDelay: "9s",
        }}
      />

      <style>{`
        @keyframes ai-blob {
          0%, 100% { transform: translate3d(0, 0, 0) scale(1); }
          33%      { transform: translate3d(40px, -28px, 0) scale(1.06); }
          66%      { transform: translate3d(-26px, 30px, 0) scale(0.96); }
        }
      `}</style>
    </div>
  );
};

export default AIBackground;
